export default __webpack_public_path__ + "static/media/EmptyLog.24ba27cf.png";